export default {"src":"/_next/static/media/BGC.581a150b.svg","height":18,"width":18};